import { TIME_UNIT } from 'emma-common-ts';
import { TimeUnit, timeUnits } from './emma-timeago.helper';

export const units: Array<TimeUnit> = timeUnits.map((u) => {
  let label;
  switch (u.value) {
    case TIME_UNIT.SECONDS:
      label = $localize`Segundos`;
      break;
    case TIME_UNIT.MINUTES:
      label = $localize`Minutos`;
      break;
    case TIME_UNIT.HOURS:
      label = $localize`Horas`;
      break;
    case TIME_UNIT.DAYS:
      label = $localize`Días`;
      break;
    case TIME_UNIT.WEEKS:
      label = $localize`Semanas`;
      break;
    case TIME_UNIT.MONTHS:
      label = $localize`Meses`;
      break;
    case TIME_UNIT.YEARS:
      label = $localize`Años`;
      break;
  }
  return { ...u, label };
});

export const unitsMapping: { [k in TIME_UNIT]: { [k: string]: string } } = {
  [TIME_UNIT.SECONDS]: {
    '=1': $localize`# segundo`,
    other: $localize`# segundos`,
  },
  [TIME_UNIT.MINUTES]: {
    '=1': $localize`# minuto`,
    other: $localize`# minutos`,
  },
  [TIME_UNIT.HOURS]: {
    '=1': $localize`# hora`,
    other: $localize`# horas`,
  },
  [TIME_UNIT.DAYS]: {
    '=1': $localize`# día`,
    other: $localize`# días`,
  },
  [TIME_UNIT.WEEKS]: {
    '=1': $localize`# semana`,
    other: $localize`# semanas`,
  },
  [TIME_UNIT.MONTHS]: {
    '=1': $localize`# mes`,
    other: $localize`# meses`,
  },
  [TIME_UNIT.YEARS]: {
    '=1': $localize`# año`,
    other: $localize`# años`,
  },
};
